export const PERSONAL_INFO = 'personalinfo';
export const INCOME = 'income';
export const EXPENSES = 'expenses';
export const RISK_TOLERANCE = 'risktolerance';
export const TAX_FILING = 'taxfiling';
export const GOALS = 'goals';
export const OTHER_ASSETS = 'otherassets';
export const ACCOUNTS_REACT = 'accountsReact';
export const LINK_ACCOUNTS = 'linkAccounts';
export const INSURANCE = 'insurance';
export const STOCK_OPTIONS = 'stockoptions';
